import React, { useState, useEffect } from "react";
import "./App.css";
import BlockerModal from "./components/Modal/BlockerModal";
import ProtectedRoute from "./components/ProtectedRoute";
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Registration from "./pages/Registration";
import StudentDetail from "./pages/StudentDetail";
import Login from "./pages/Login";
import GuardianHome from "./pages/GuardianHome";
import EnrollmentWizard from "./pages/EnrollmentWizard";

function App() {
  const [isBlocked, setIsBlocked] = useState(false);

  useEffect(() => {
    const currentTime = new Date();
    const dateTest = new Date("2023-08-12T01:11:10+07:00");
    const isTest = false;

    const hours = (isTest ? dateTest : currentTime)
      .getHours()
      .toString()
      .padStart(2, "0");

    setIsBlocked(Number(hours) < 6 || Number(hours) > 23);
  }, []);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/home",
      element: (
        <ProtectedRoute>
          <GuardianHome />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ghi-danh",
      element: (
        <ProtectedRoute>
          <EnrollmentWizard />
        </ProtectedRoute>
      ),
    },
    {
      path: "/registration-summary/:yearId",
      element: <Registration isBlocked={isBlocked} />,
    },
    {
      path: "/student/:id",
      element: (
        <ProtectedRoute>
          <StudentDetail />
        </ProtectedRoute>
      ),
    },
    // Dev-only: preview the QR/payment step UI without backend or login.
    // Open /preview-qr?preview=qr . Not registered in production builds.
    ...(process.env.NODE_ENV === "development"
      ? [{ path: "/preview-qr", element: <EnrollmentWizard /> }]
      : []),
  ]);

  return (
    <>
      <BlockerModal isShowModal={isBlocked} />
      <RouterProvider router={router} />
    </>
  );
}

export default App;
